export interface SentOtpOfLogin {
    mobile: string;
    otpPlatform?: string;
    recaptchaToken?: string;
}
export interface VerifyOtpOfLogin {
    mobile: string;
    otp: string;
    appsflyerId: string;
}
export interface RegisterByPan {
    referralCode?: string;
    appsflyerId?: string;
    advertisingId?: string;
    linkedInId?: string;
    educationQualification?: string;
    vehicleOwnerShip?: string;
    vehicleType?: string;
    earningMember?: string;
    monthlyHouseHoldIncome?: string;
    employmentStatus?: string;
    salaryRange?: string;
}

export const EmploymentStatus = {
    // NONE: { value: "0", name: "None" },
    SALARIED: { value: "1", name: "Salaried", icon: "assets/svg/icons/currency-receipt-outline-gb.svg" },
    SELF_EMPLOYEE: { value: "2", name: "Self-Employed", icon: "assets/svg/icons/person-gb.svg" },
    // STUDENT: { value: "3", name: "Student" },
};

export const OtpVia = {
    SMS: {
        value: "0",
        name: "SMS",
        inactiveIcon: "assets/svg/icons/social-sms-outline.svg",
        activeIcon: "assets/svg/icons/social-sms-fill.svg",
        className: "sms-outline-btn",
    },
    WHATSAPP: {
        value: "1",
        name: "Whatsapp",
        inactiveIcon: "assets/svg/icons/social-whatsapp-outline.svg",
        activeIcon: "assets/svg/icons/social-whatsapp-fill.svg",
        className: "whatsapp-outline-btn",
    },
};
export interface userRedirect {
    [key: string]: any;
    utm_source?: any;
    utm_medium?: any;
    utm_campaign?: any;
    utm_id?: any;
    utm_term?: any;
    utm_content?: any;
    click_id?: any;
    gclid?: any;
    gbraid?: any;
    fbclid?: any;
    comeFromGoogleOrDirect?: any;
}

export enum ActiveKYCMode {
    OLD_MODE = "1",
    NEW_MODE = "2",
}
